import { Icon } from "@iconify/react";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import List from "../../List";
import ListStyle3 from "../../List/ListStyle3";
import ListStyle2 from "../../List/ListStyle2";
import Spacing from "../../Spacing";
import styled from "styled-components";
import { linearTopGradient, linearTopGradient2, primaryColor, tuftsBlue } from "../../../constants/colors";
import { useSelector } from "react-redux";
import DoctorRating from "./comps/DoctorRating";
import DoctorReviewList from "./comps/DoctorReviewList";
import axiosInstance from "../../../utils/axiosInstance";
import { fetchDoctorReviews } from "../../../constants/ApiConstants";
import { FaStar } from "react-icons/fa6";
import { isDesktop } from "../../../utils/utils";
import Button from "../../Button";

export default function DoctorDetailsSection({ id, bgUrl, infoEditable = false, imgUrl, name, designation, description, degrees, languages, experience_year, total_patients_cured, educational_journey, consultation_fee, rating, services, expertise, service_locations, experience, awards }) {
  const location = useLocation();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const tabs = ["Details", "Reviews", "Education", "Experiences", "Awards"];
  const { settings, userData } = useSelector((state) => state.appSlice);

  const [reviews, setReviews] = useState([]);
  const [reviewLoading, setReviewLoading] = useState(false);
  const [reviewStart, setReviewStart] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    setReviewLoading(true);
    axiosInstance
      .post(fetchDoctorReviews, {
        doctor_id: id,
        start: reviewStart,
        count: 10,
      })
      .then((res) => {
        setReviews([...reviews, ...res.data.data]);
      })
      .finally((_) => {
        setReviewLoading(false);
      });
  }, []);
  const onBookClick = () => {
    if (!userData) {
      navigate(`/login?redirect=${location.pathname}`);
      return;
    }
    navigate(`/date-select/${id}`);
  };

  const onChatClick = () => {
    if (!userData) {
      navigate(`/login?redirect=${location.pathname}`);
      return;
    }
    //  navigate to chat page
  };
  return (
    <Wrapper className="cs_doctor_details">
      <Spacing md="85" />
      <div className="container">
        <div className="row">
          <div className="col-lg-5">
            <div className="cs_single_doctor overflow-hidden cs_radius_20">
              <img src={imgUrl} alt="Doctor" style={{ width: "100%", maxWidth: "600px", aspectRatio: 1, objectFit: "contain" }} />
              {isDesktop && <Button btnText={"Manage Settings"} btnUrl={"/doctor-settings"} />}
            </div>
            {!infoEditable && (
              <div className="bookNowContainer">
                <button type="button" onClick={onBookClick}>{`Book Now: ${settings.currency}${consultation_fee}`}</button>
                <button className="btnChat">CHAT</button>
              </div>
            )}

            <Spacing md="94" lg="60" />
          </div>
          <div className="col-lg-6 offset-lg-1 position-relative">
            <div className="d-flex justify-content-between align-items-center">
              <strong className="dName">{name}</strong>
              <div className="rating-badge d-flex align-items-center">
                <span className="" style={{ color: "orange" }}>
                  {parseFloat(rating)}
                </span>
                <FaStar size={14} color="orange" />
              </div>
            </div>

            <strong className="dDesignation">{designation}</strong>
            <strong className="dDegrees">{degrees}</strong>

            <div className="info__cardWrapper">
              <div className="info__card">
                <div>
                  <span className="info__Card_value">{experience_year}</span>
                  {` Years`}
                </div>
                <div>EXPERIENCE</div>
              </div>
              <div className="info__card">
                <div>
                  <span className="info__Card_value">{total_patients_cured}</span>
                  {``}
                </div>
                <div>HAPPY PATIENTS</div>
              </div>
            </div>
            <div className="tabWrapper mobileTabs">
              {tabs.map((tab, i) => (
                <div onClick={() => setSelectedTabIndex(i)} key={i} className="tabItem" style={{ backgroundColor: i === selectedTabIndex ? tuftsBlue : "#f3f3f3", color: i === selectedTabIndex ? "#fff" : "gray" }}>
                  {tab}
                </div>
              ))}
            </div>
            <div className="mobileDoctor_infos">
              {selectedTabIndex === 0 && (
                <>
                  <div className="section_cl">
                    <div className="mSection__title">ABOUT DR.</div>
                    <p className="font-normal">{description}</p>
                  </div>
                  <div className="section_cl">
                    <div className="d-flex justify-content-between align-items-center w-full">
                      <div className="mSection__title">LANGUAGES</div>
                      {/* {infoEditable && (
                        <Link to={"/manage-doctor-languages"} className="fs-normal text-sprimary">
                          Manage
                        </Link>
                      )} */}
                    </div>
                    <div className="lngwrapper">
                      {languages.split(",").map((lang) => (
                        <div key={lang} className="lang__chip">
                          {lang}
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="section_cl">
                    <div className="d-flex justify-content-between align-items-center w-full">
                      <div className="mSection__title">SERVICES</div>
                      {infoEditable && (
                        <Link to={"/doctor-settings/edit-doctor-profile/manage-services"} className="fs-normal text-sprimary">
                          Manage
                        </Link>
                      )}
                    </div>
                    {services.length === 0 ? (
                      <p className="font-normal">{"No Service Available"}</p>
                    ) : (
                      <div className="d-flex flex-column gap-1">
                        {services.map((service) => (
                          <span key={service.id} className="text-grey2 fs-normal">
                            {service.title}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="section_cl">
                    <div className="d-flex justify-content-between align-items-center w-full">
                      <div className="mSection__title">EXPERTISE</div>
                      {infoEditable && (
                        <Link to={"/doctor-settings/edit-doctor-profile/manage-expertises"} className="fs-normal text-sprimary">
                          Manage
                        </Link>
                      )}
                    </div>
                    {services.length === 0 ? (
                      <p className="font-normal">{"No Expertise Available"}</p>
                    ) : (
                      <div className="d-flex flex-column gap-1">
                        {expertise.map((expert) => (
                          <span key={expert.id} className="text-grey2 fs-normal">
                            {expert.title}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="section_cl">
                    <div className="d-flex justify-content-between align-items-center w-full">
                      <div className="mSection__title">SERVICE LOCATIONS</div>
                      {infoEditable && (
                        <Link to={"/doctor-settings/edit-doctor-profile/manage-service-locations"} className="fs-normal text-sprimary">
                          Manage
                        </Link>
                      )}
                    </div>
                    {service_locations.length === 0 ? (
                      <p className="font-normal">{"No Service Location Available"}</p>
                    ) : (
                      <div className="d-flex flex-column gap-1">
                        {service_locations.map((serviceLocation) => (
                          <div className="d-flex flex-column">
                            <strong key={serviceLocation.id} className="py-0 fs-normal text-black">
                              {serviceLocation.hospital_title}
                            </strong>
                            <span className="py-0 fs-sm text-grey2">{serviceLocation.hospital_address}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </>
              )}
              {selectedTabIndex === 1 && (
                <>
                  <div className="section_cl">
                    <div className="mSection__title">Reviews</div>
                    <DoctorRating rating={rating} />
                    <DoctorReviewList reviews={reviews} />
                  </div>
                </>
              )}
              {selectedTabIndex === 2 && (
                <>
                  <div className="section_cl mt-3">
                    <p className="font-normal">{educational_journey}</p>
                  </div>
                </>
              )}
              {selectedTabIndex === 3 && (
                <>
                  <div className="section_cl mt-3">
                    {experience.map((exp) => (
                      <p key={exp.id} className="text-grey2 fs-normal bg-grey2  p-2 rounded m-0 mb-2">
                        {exp.title}
                      </p>
                    ))}
                  </div>
                </>
              )}
              {selectedTabIndex === 4 && (
                <>
                  <div className="section_cl mt-3">
                    {awards.map((award) => (
                      <div className="d-flex gap-1 bg-grey2 align-items-center gap-2 p-2 rounded m-0 mb-2">
                        <img src="/images/icons/ic_award.png" style={{ height: 18 }} />
                        <p key={award.id} className="text-grey2 fs-normal p-0 m-0">
                          {award.title}
                        </p>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
            {/* <div className="cs_social_links cs_accent_bg cs_radius_15">
              {social?.map((item, index) => (
                <Link to={item.href} key={index}>
                  <Icon icon={item.icon} />
                </Link>
              ))}
            </div> */}
            <Spacing md="200" xl="150" lg="80" />
            <Spacing md="35" lg="0" />
            {/* <List heading={degreesHeading} iconUrl="/images/icons/graduation.svg" data={degrees} /> */}
            {/* <Spacing md="70" lg="50" />
            <List heading={experiencesHeading} iconUrl="/images/icons/experience.svg" data={experiences} />
            <Spacing md="70" lg="50" />
            <List heading={awardHeading} iconUrl="/images/icons/award2.svg" data={awards} /> */}
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
const Wrapper = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  .bookNowContainer {
    background: ${linearTopGradient};
    outline: none;
    border: none;
    padding: 8px 8px 8px 8px;
    border-radius: 6px;
    display: flex;
    justify-content: space-between;
    margin-top: 1rem;
  }
  .bookNowContainer button {
    outline: none;
    border: none;
    padding: 12px 24px 12px 24px;
    background: #ffffff29;
    color: #fff;
    border-radius: 8px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    transition: all ease-in-out 0.3s;
    &:hover {
      background: ${primaryColor};
    }
    &:nth-child(1) {
      flex: 3;
      margin-right: 0.5rem;
    }
    &:nth-child(2) {
      flex: 1;
    }
  }

  .tabWrapper {
    display: flex;
    gap: 14px;
    margin-top: 2rem;
    overflow-x: scroll;

    &::-webkit-scrollbar {
      display: none;
    }
    .tabItem {
      cursor: pointer;
      padding: 6px 16px;
      border-radius: 30px;
      color: gray;
      font-size: 0.9rem;
      transition: all ease-in-out 0.3s;
    }
  }
  .rating-badge {
    background-color: #fff1d7;
    padding-left: 0.6rem;
    padding-right: 0.6rem;
    gap: 0.3rem;
    border-radius: 20px;
  }
  strong {
    display: block;
  }
  .dName {
    margin-top: 2rem;
    color: #000;
  }
  .dDesignation {
    font-weight: 400;
    color: ${tuftsBlue};
    font-weight: 400;
    font-size: 0.9rem;
  }
  .dDegrees {
    font-weight: 400;
    font-size: 0.85rem;
    color: gray;
  }

  .info__cardWrapper {
    display: flex;
    margin-top: 1rem;
    overflow-x: scroll;
    gap: 16px;

    &::-webkit-scrollbar {
      display: none;
    }
    .info__card {
      background-color: #f5f5f5;
      color: ${tuftsBlue};
      font-size: 0.85rem;
      padding: 8px 16px;
      border-radius: 8px;
      flex: 1;

      .info__Card_value {
        color: #000;
        font-weight: bold;
        display: inline-flex;
        align-items: center;
      }
    }
  }
  .mSection__title {
    color: #000;
    margin-top: 1.2rem;
    margin-bottom: 0.3rem;
    font-size: 0.8rem;
    font-weight: 600;
  }
  .font-normal {
    font-size: 0.9rem;
    color: #969696;
  }

  .lngwrapper {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    .lang__chip {
      background-color: #ececec;
      padding: 4px 12px;
      border-radius: 30px;
      font-size: 0.85rem;
    }
  }

  @media screen and (min-width: 768px) {
    .dName {
      font-size: 3rem;
      margin-bottom: 1rem;
    }
    .tabWrapper {
      flex-wrap: wrap;
    }
  }
  @media screen and (max-width: 768px) {
    .bookNowContainer {
      position: fixed;
      bottom: -2px;
      z-index: 1;
      left: 0;
      right: 0;
      border-radius: 0;
    }
  }
`;
